export * from './logo-moises'
